/**
 * @file       Layout module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import Vue from "vue";
import Default from "@/layouts/default.vue";
import List from "@/layouts/list.vue";
import Auth from "@/layouts/auth.vue";
import Basic from "@/layouts/basic.vue";
import Dlibr from "@/layouts/dlibr.vue";

Vue.component("default-layout", Default);
Vue.component("list-layout", List);
Vue.component("auth-layout", Auth);
Vue.component("basic-layout", Basic);
Vue.component("dlibr-layout", Dlibr);
